import { Directive, ElementRef, EventEmitter, HostListener, Output } from '@angular/core';

@Directive({
  standalone: true,
  selector: '[nkClickOutside]',
})
export class ClickOutsideDirective {
  @Output() public clickOutside = new EventEmitter<void>();

  constructor(private _elRef: ElementRef) {}

  @HostListener('document:mousedown', ['$event'])
  private _clickOutside(event: Event): void {
    const elem = this._elRef.nativeElement as HTMLElement;
    if (elem && !elem.contains(event.target as Node)) {
      this.clickOutside.next();
    }
  }
}
